/* eslint camelcase: 0 */
import { Result } from '@/infrastructure/network/Zipcloud/schema/models'
import { IAddressProps } from '@/entities/Zipcloud/Address'

export const toSearchProps = (props: Result): IAddressProps => {
  const { address1, address2, address3 } = props

  return {
    prefecture: address1,
    city: address2 + address3
  }
}
